module.exports = __webpack_public_path__ + "img/home.36818fff.svg";